import { useEffect } from "react";
import { useHistory } from "react-router-dom";

/** Legacy route — WhatsApp inbox now lives under Sonic Conversations. */
const WhatsappInbox = () => {
  const history = useHistory();

  useEffect(() => {
    history.replace("/console/sonic?tab=conversations");
  }, [history]);

  return null;
};

export default WhatsappInbox;
